// react
import { useEffect, useState } from "react";
// react redux
// import { useSelector } from "react-redux";
// icons
import Ripple from "../../ui/spinners/ripple/Ripple";
// import MenuItems from "../DropDown/MenuItems";
// import { useDispatch } from "react-redux";
// import { setExpandedIndex } from "../../../redux/menuTracker";

import { AiOutlinePlusSquare, AiOutlineMinusSquare } from "react-icons/ai";

const ProductsFilter = ({
  // carList,
  brands,
  // carListLoading,
  brandsLoading,
  filterSkus,
  filtersShown,
  // filterParams,
  // reset,
}) => {
  // const selectedCar = useSelector((state) => state.car.selectedCar);
  // const [showCars, SetShowCars] = useState(true);
  const [showBrands, SetshowBrands] = useState(true);

  // const dispatch = useDispatch();
  // brands filters
  const [checkedBrands, setCheckedBrands] = useState(null);

  const brandChangedHandler = (brandId) => {
    const targetBrandId = brandId;
    const isIncluded = checkedBrands?.includes(targetBrandId);
    if (isIncluded) {
      setCheckedBrands((prevCheckedBrands) =>
        prevCheckedBrands.filter((brand) => brand !== targetBrandId)
      );
    } else {
      setCheckedBrands((prevCheckedBrands) => {
        if (prevCheckedBrands) {
          return [...prevCheckedBrands, targetBrandId];
        } else {
          return [targetBrandId];
        }
      });
    }
  };

  useEffect(() => {
    if (checkedBrands) {
      filterSkus({
        skuBrandIdList: checkedBrands.join(),
      });
    }
  }, [checkedBrands, filterSkus]);

  const brandsList = brands
    ? brands.map((brand) => (
        <li
          key={`${brand.brandName}|${brand.id}`}
          className="flex items-center gap-2"
        >
          <input
            id={`${brand.brandName}|${brand.id}`}
            type="checkbox"
            name={`${brand.brandName}|${brand.id}`}
            checked={checkedBrands?.includes(brand.id) || false}
            onChange={() => brandChangedHandler(brand.id)}
          />
          <label htmlFor={`${brand.brandName}|${brand.id}`}>
            {brand.brandName}
          </label>
        </li>
      ))
    : null;

  // reset filters handler
  // const [resetDropDown, setResetDropDown] = useState(false);

  // const resetFiltersHandler = () => {
  //   setCheckedBrands([]);
  //   reset();
  //   setResetDropDown(true);
  //   dispatch(setExpandedIndex({}));
  // };
  // const carsHandler = () => {
  //   SetShowCars(!showCars);
  // };
  const brandsHandler = () => {
    SetshowBrands(!showBrands);
  };
  // const isClearFiltersDisabled = () => {
  //   let disabled = true;
  //   if (
  //     selectedCar.brand ||
  //     selectedCar.model ||
  //     selectedCar.year ||
  //     selectedCar.carDetails
  //   ) {
  //     disabled = false;
  //     return disabled;
  //   }

  //   for (let key in filterParams) {
  //     if (filterParams[key]) {
  //       disabled = false;
  //     }
  //   }
  //   return disabled;
  // };

  return (
    <aside
      className={[
        "w-300",
        "shrink-0",
        "border",
        "border-light-gray",
        "rounded-lg",
        "fixed",
        "lg:relative",
        "top-0",
        "right-0",
        "lg:right-auto",
        "lg:top-auto",
        "translate-x-full",
        "lg:translate-x-0",
        "lg:right-auto",
        "h-screen",
        "lg:h-fit",
        "overflow-y-scroll",
        "lg:overflow-y-auto",
        "transition-all",
        filtersShown ? "rounded-none w-250 translate-x-0 z-40 bg-white" : "",
      ].join(" ")}
    >
      {/* <div dir="rtl" className="my-6 mx-6">
        <h4 className="mb-6 flex justify-between items-center">
          <button className="flex gap-2 items-center" onClick={carsHandler}>
            {!showCars ? (
              <AiOutlinePlusSquare size={20} />
            ) : (
              <AiOutlineMinusSquare size={20} />
            )}
            السيارات :
          </button>

          <button
            className="text-sm text-red-400 p-1 border border-light-gray rounded disabled:bg-light-gray disabled:text-gray-300 disabled:cursor-not-allowed"
            onClick={resetFiltersHandler}
            disabled={isClearFiltersDisabled()}
          >
            محو التصفية
          </button>
        </h4>
        {carListLoading ? (
          <Ripple className="border-dark-blue" />
        ) : (
          <ul>
            {showCars
              ? carList.map((menu, index) => {
                  const depthLevel = 0;
                  return (
                    <MenuItems
                      setExpandedIndex={setExpandedIndex}
                      items={menu}
                      key={index}
                      index={index}
                      depthLevel={depthLevel}
                      // expandedIndex={expandedIndex}
                      setResetDropDown={setResetDropDown}
                      resetDropDown={resetDropDown}
                    />
                  );
                })
              : null}
          </ul>
        )}
      </div>

      <hr /> */}

      <div className="my-6 mx-6">
        <h4 className="mb-6">
          <button className="flex gap-2 items-center" onClick={brandsHandler}>
            {!showBrands ? (
              <AiOutlinePlusSquare size={20} />
            ) : (
              <AiOutlineMinusSquare size={20} />
            )}
            الماركات :
          </button>
        </h4>

        {brandsList ? (
          <ul className="space-y-4">
            {brandsLoading ? (
              <Ripple className="border-dark-blue" />
            ) : showBrands ? (
              brandsList
            ) : null}
          </ul>
        ) : (
          ""
        )}
      </div>

      <hr />
    </aside>
  );
};

export default ProductsFilter;
